/**
 * 自社入札フィルタリング (= market board タブ用)。
 *
 * 既存 ListBiddingIntradayOrders の結果から選択中コマに一致する行を抽出する。
 * read-only 表示用 (= Phase 3 まで編集・取消は実装しない)。
 */
import type { IntradayOrderRow } from '~/hooks/bidding/useListBiddingIntradayOrders'

/**
 * 自社注文から選択中コマの行を抽出する。
 *
 * @param orders - 全注文一覧
 * @param timeCode - 選択中コマ番号 (1〜48)
 * @returns 選択コマに一致する注文行
 */
export function filterMyBidsByKoma(
  orders: IntradayOrderRow[],
  timeCode: number,
): IntradayOrderRow[] {
  return orders.filter((o) => o.timeCode === timeCode)
}
